import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";
import ImageUpload from "../ImageFolder/ImageUpload";

import {
  createDiseaseAPI,
  createGroupAPI,
  createLabTest,
  createPackageTestAPI,
  createSubGroupAPI,
  deleteLabTest,
  deletePackageTest,
  deleteTestCategory,
  deleteTestSubCategory,
  getTestListsAPI,
  listDiseaseAPI,
  listGroupAPI,
  listPackageAPI,
  listSubGroupAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updateLabTestAPI,
  updatePackageTestAPI,
  updateSubGroupAPI,
} from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import {
  categoryDDAPI,
  categoryPackageDDAPI,
  categoryTestDDAPI,
  generateFileAPI,
  groupDDAPI,
  subCategoryDDAPI,
  testDDAPI,
} from "../../api/dropdown";
import MySelect from "../../MyComp/UI/form/MySelect";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import DiscountValidation from "../../MyComp/UI/form/DiscountValidation";

const PackageTest = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [loading, setLoading] = useState(false);

  const isLoading = watch("isLoading");
  const data = watch("data");
  const [tableData, setTableData] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [perPage, setPerPage] = useState(25);

  const [itemPerPage, setItemPerPage] = useState(25);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Table Columns
  // const [column, setColumn] = useState(
  //   [
  //   //   {
  //   //     name: "test Name",
  //   //     sortable: true,
  //   //     wrap: false,
  //   //     cell: (row) => {
  //   //       const fullName = row?.test_name || "";
  //   //       return (
  //   //         <div
  //   //           title={fullName}
  //   //           style={{
  //   //             maxWidth: "150px",
  //   //             overflow: "hidden",
  //   //             cursor: "pointer",
  //   //           }}
  //   //         >
  //   //           {truncateByCharacters(fullName, 14)}
  //   //         </div>
  //   //       );
  //   //     },
  //   //   },

  //   {
  //     name: "Test",
  //     sortable: true,
  //     wrap: false,
  //     cell: (row) => {
  //       const fullName = row?.TestName || "";
  //       return (
  //         <div
  //           title={fullName}
  //           style={{
  //             maxWidth: "150px",
  //             overflow: "hidden",
  //             cursor: "pointer",
  //           }}
  //         >
  //           {truncateByCharacters(fullName, 14)}
  //         </div>
  //       );
  //     },
  //   },

  //   {
  //     name: "Group",
  //     selector: (row) => row?.Category || "-",
  //     sortable: true,
  //     wrap: true,
  //   },

  //   {
  //     name: "Net",
  //     selector: (row) => row?.Net || "-",
  //     sortable: true,
  //     wrap: true,
  //   },
  //   //    {
  //   //     name: "Discount",
  //   //     selector: (row) => row?.discount || "-",
  //   //     sortable: true,
  //   //     wrap: true,
  //   //   },
  //   {
  //     name: "MRP",
  //     selector: (row) => row?.MRP || "-",
  //     sortable: true,
  //     wrap: true,
  //   },
  //   {
  //     name: "Discount",
  //     selector: (row) => row?.disc_perc || "-",
  //     sortable: true,
  //     wrap: true,
  //   },
  //   // {
  //   //   name: "Discount type",
  //   //   selector: (row) => row?.discount_type || "-",
  //   //   sortable: true,
  //   //   wrap: true,
  //   // },
  //   {
  //     name: "Type",
  //     selector: (row) => row?.Type || "-",
  //     sortable: true,
  //     wrap: true,
  //   },

  //   {
  //     name: "Status",
  //     selector: (row) => row?.status,
  //     cell: (row) => (
  //       <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
  //         <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
  //       </div>
  //     ),
  //     sortable: true,
  //     wrap: true,
  //     width: "90px",
  //   },

  //   {
  //     name: "Action",
  //     wrap: true,
  //     width: "120px",
  //     cell: (row) => (
  //       <div>
  //         <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
  //           <Icon name="edit" />
  //         </Button>
  //         <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
  //           <Icon name="trash" />
  //         </Button>
  //       </div>
  //     ),
  //   },
  // ]);
  const columns = [
    //   {
    //     name: "test Name",
    //     sortable: true,
    //     wrap: false,
    //     cell: (row) => {
    //       const fullName = row?.test_name || "";
    //       return (
    //         <div
    //           title={fullName}
    //           style={{
    //             maxWidth: "150px",
    //             overflow: "hidden",
    //             cursor: "pointer",
    //           }}
    //         >
    //           {truncateByCharacters(fullName, 14)}
    //         </div>
    //       );
    //     },
    //   },

    {
      name: "Test",
      sortable: true,
      wrap: true,
      cell: (row) => {
        const fullName = row?.TestName || "";
        return (
          <div
            title={fullName}
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullName, 14)}
          </div>
        );
      },
    },

    {
      name: "Group",
      selector: (row) => row?.Category || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Net",
      selector: (row) => row?.Net || "-",
      sortable: true,
      wrap: true,
    },
    //    {
    //     name: "Discount",
    //     selector: (row) => row?.discount || "-",
    //     sortable: true,
    //     wrap: true,
    //   },
    {
      name: "MRP",
      selector: (row) => row?.MRP || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Discount",
      selector: (row) => row?.disc_perc || "-",
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Discount type",
    //   selector: (row) => row?.discount_type || "-",
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Type",
      selector: (row) => row?.Type || "-",
      sortable: true,
      wrap: true,
    },
  {
      name: "Discount Type",
      selector: (row) => row?.discount_type || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "90px",
    },

    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" />
          </Button>
        </div>
      ),
    },
  ];
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
    };
    setLoading(true);
    getPackageList(body)
      .then((res) => {
        const status = res.data.status;
        console.log(res, "resss");
        if (status === true) {
          setLoading(false);
          console.log("limit", res?.data?.data?.totalRecords);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.medicines);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };

  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
    setValue("isLoading", true);

    deleteLabTest({ id: watch("selectedRow").id })
      .then((res) => {
        setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
          getPackageList({
      page: currentPage,
      limit: itemPerPage,
    });
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };
  // Fetch group list
  useEffect(() => {
    const body = {
      // search: debouncedSearch,
      page: currentPage,

      limit: itemPerPage,

      // labId: labId
    };
    getPackageList(body);
  }, []);

  const getPackageList = async (body) => {
    try {
      setValue("isLoading", true);

      const res = await getTestListsAPI(body);

      if (res?.data?.status === true) {
        console.log( res?.data?.data," res?.data?.data")
        const list = res?.data?.data?.tests || [];
        const total = res?.data?.data?.total || 0;
        setTableData(res?.data?.data?.tests);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
        setValue("data", list);
        // setTotalRows(total); // 👈 set total count
      } else if (res?.data?.status === "expired") {
        setTableData([]);
        logout();
      } else {
        setValue("data", []);
        setTotalRows(0);
        toast.error(res?.data?.message);
      }
    } catch (err) {
      setValue("data", []);
      setTotalRows(0);
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };

  useEffect(() => {
    const body = {
      page: currentPage,
      limit: itemPerPage,
    };
    getPackageList(body);
  }, []);

  useEffect(() => {
    getPackageList({
      page: currentPage,
      limit: itemPerPage,
    });
  }, [currentPage, itemPerPage]);

  const onFormSubmit = async (data) => {
    try {
      setValue("isLoading", true);

      const isEdit = mode === "Edit";
      const selectedRow = watch("selectedRow");

      const payload = {
        Category: data?.category?.label || "",
        TestName: data?.test || "",
        Net:data.net||"",
        MRP: Number(data?.price) || 0,
        disc_perc: Number(data?.discount) || 0,
        discount_type: data?.discount_type?.value || "",

        categoryId: data?.category?.value || selectedRow?.categoryId || "",

        subcategoryId: data?.subcategory?.value || selectedRow?.subcategoryId || "",

        Type: data?.subcategory?.label || selectedRow?.Type || "",

        status: data?.status?.value ?? true,
      };

      if (isEdit) {
        payload.id = selectedRow?.id;
      }

      console.log("FINAL PAYLOAD:", payload);

      const res = isEdit ? await updateLabTestAPI(payload) : await createLabTest(payload);

      if (res?.data?.status === true) {
        toast.success(res.data.message);

        await getPackageList({
          page: currentPage,
          limit: itemPerPage,
        });

        resetF();
        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };

  const handleEdit = async (row) => {
    window.scrollTo(0, 0);

    setMode("Edit");
    setIsOpen(true);
    resetF();
    setValue("selectedRow", row);

    setValue("category", {
      label: row.Category,
      value: row.categoryId,
    });

    await getSubCategory(row.categoryId);

    setValue("subcategory", { value: row.subcategoryId, label: row.Type });

    setValue("test", row.TestName || "");

    if (row.discount_type) {
      setValue("discount_type", {
        label:
          row.discount_type === "fixed"
            ? "fixed"
            : row.discount_type === "percentage"
              ? "percentage"
              : row.discount_type,
        value: row.discount_type,
      });
    }

    setValue("discount", row.disc_perc || "");

    setValue("mrp", row.MRP || "");
    setValue("price", row.MRP || "");
    setValue("net", row.Net || "");
    

    // 8️⃣ Status
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
    
  };

  useEffect(() => {
    getPackage();
  }, [mode]);
  const getPackage = () => {
    setValue("isLoading", true);
    categoryPackageDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("packageDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("packageDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const categoryId = watch("category")?.value;
    const subCategoryId = watch("subcategory")?.value;

    if (categoryId) {
      getSubCategory(categoryId);
    } else {
      setValue("subCategoryDD", []);
    }

    if (categoryId && subCategoryId) {
      // getTest(categoryId, subCategoryId);
    } else {
      setValue("testDD", []);
    }
  }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    // setValue("test", null);
  }, [watch("category"), watch("subcategory")]);
  useEffect(() => {
    setValue("subcategory", null);
  }, [watch("category")]);
  const getTest = (categoryId, subCategoryId) => {
    const body = {
      categoryId,
      subCategoryId,
    };

    testDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("testDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          setValue("testDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const getSubCategory = (categoryId) => {
    const body = { categoryId };

    subCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };
  const discountType = [
    { value: "percentage", label: "percentage" },
    {
      value: "fixed",
      label: "fixed",
    },
  ];
  const resetF = () => {
    setValue("mrp", null);
    setValue("discount", null);
    setValue("discountType", null);
    setValue("test", null);
    setValue("status", null);
    setValue("subcategory", null);
    setValue("category", null);
    setValue("group_img", null);
    setValue("net", null);
    setValue("discount_type", null);
    setValue("price", null);
    // trigger();
    clearErrors()
    // trigger(["price"])
  };
  const generateFile=()=>{
  
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data,"res.fileee")
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });

  }
useEffect(() => {
    const price = watch("price");
    const discount = watch("discount");
    const discountType = watch("discount_type");

    if (price && discount && discountType) {
      let netPrice = parseFloat(price);
      const discountValue = parseFloat(discount);

      if (discountType.value === "percentage") {
        netPrice = price - price * (discountValue / 100);
      } else if (discountType.value === "fixed") {
        netPrice = price - discountValue;
      }

      netPrice = Math.max(0, netPrice);

      setValue("net", netPrice.toFixed(2));

      trigger("net");
      trigger("price");
      // trigger("discount")
    } else {
      setValue("net", "");
      //  setValue("discount", "");
        //  setValue("discount_type", "");
    }
  }, [watch("price"), watch("discount"), watch("discount_type")]);
  return (
    <>
      <Head title=" Package | Master" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Test
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className={"me-2"}   >
                <div className="me-2 d-flex g-5 mt-2">
               
              <Button
                color="primary"
                outline
                className="me-n1  mx-2"
                onClick={() => {
                  setIsOpen((pre) => !pre);
                  setMode("Add");
                  resetF();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button></div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  {/* <Col>
                        <MySelect
                                          register={register}
                                          watch={watch}
                                          setValue={setValue}
                                          trigger={trigger}
                                          errors={errors}
                                          title={"Package"}
                                          name={"package_name"} // ✅ correct
                                          placeholder={"Select Package"}
                                          required
                                          options={watch("packageDD")}
                                        />
                                      </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"package"}
                      name={"package"}
                      placeholder={"Select package"}
                      required
                      options={watch("packageDD")}
                      // multi
                    />
                  </Col> */}
                  <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Group"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>
                  <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Group"}
                      name={"subcategory"}
                     
                      placeholder={"Select Sub Group"}
                      required
                      options={watch("subCategoryDD")}
                      // multi
                    />
                  </Col>
                  {/* <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Test"}
                      name={"test"}
                      placeholder={"Select test"}
                      required
                      options={watch("testDD")}
                      // multi
                    />
                  </Col> */}
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Test Name"
                      name="test"
                      placeholder="Enter Test name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                    <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Price"
                      name="price"
                      placeholder="Enter price"
                      required
                      min={0.01}
                      validation={{
                        validate: (value) => {
                          if (value <= 0) return "Price must be greater than 0";
                          return true;
                        },
                      }}
                    />
                  </Col>

                  <Col md={4}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Type"}
                      name={"discount_type"}
                      placeholder={"Select type"}
                      required
                      options={[
                        { value: "percentage", label: "percentage" },
                        { value: "fixed", label: "fixed" },
                      ]}
                    />
                  </Col>

                  <Col md="4" className={``}>
                    <DiscountValidation
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Discount"}
                      name={"discount"}
                      placeholder={"Enter discount"}
                      required
                      minNum={0} 
                     
                      validate={(value) => {
                        const type = watch("discount_type")?.value;
                        const price = watch("price");

                        if (!value) return true; 

                        const discountValue = parseFloat(value);
                        const priceValue = parseFloat(price);

                        if (isNaN(discountValue)) return "Please enter a valid number";

                        if (!price || isNaN(priceValue) || priceValue <= 0) {
                          return "Please enter a valid price first";
                        }

                        if (type === "percentage") {
                          if (discountValue < 0) return "Percentage cannot be negative";
                          if (discountValue > 100) return "Percentage cannot exceed 100%";

                          // Calculate actual discount amount
                          const discountAmount = (priceValue * discountValue) / 100;
                          if (discountAmount >= priceValue) {
                            return "Discount amount must be less than price";
                          }
                        } else if (type === "fixed") {
                          if (discountValue < 0) return "Discount cannot be negative";
                          if (discountValue >= priceValue) {
                            return "Fixed discount must be less than price";
                          }
                        } else {
                          return "Please select a discount type first";
                        }

                        return true;
                      }}
                    />
                  </Col>
                       <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Net"}
                      name={"net"}
                      placeholder={"Auto-calculated"}
                      readOnly
                      disabled
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Sub Group Name"
                      name="name"
                      placeholder="Enter group name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}

                  {/* <Col md="3">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Sub Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      setError={setError}
                      getValues={getValues}
                    />
                  </Col> */}

                  <Col md="4">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          {/* <MyDataTable data={data || []} columns={column} title="Package Test List" isLoading={isLoading} /> */}
          {/* <MyDataTable
            data={data || []}
            columns={column}
            title=" Test List"
            isLoading={isLoading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={itemPerPage}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
              setItemPerPage(newPerPage);
              setCurrentPage(page);
            }}
          /> */}
          <ApiPaginationDataTable
          resetF={resetF}
          // generateFile={generateFile}
            columns={columns}
            data={tableData}
            title={"Test List"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default PackageTest;
